export default function BackgroundEffects() {
  return (
    <div className="gps-bg-waves" aria-hidden="true">
      <svg
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M400 600C400 600 600 400 800 500V600H0V450C150 350 250 550 400 600Z"
          fill="url(#wave1)"
        />
        <path
          d="M500 600C500 600 700 350 800 420V600H200C350 500 400 550 500 600Z"
          fill="url(#wave2)"
          opacity="0.6"
        />
        <defs>
          <linearGradient id="wave1" x1="0" y1="400" x2="800" y2="600" gradientUnits="userSpaceOnUse">
            <stop stopColor="#139bb2" stopOpacity="0.08" />
            <stop offset="1" stopColor="#139bb2" stopOpacity="0.18" />
          </linearGradient>
          <linearGradient id="wave2" x1="200" y1="350" x2="800" y2="600" gradientUnits="userSpaceOnUse">
            <stop stopColor="#139bb2" stopOpacity="0.05" />
            <stop offset="1" stopColor="#5ec4d4" stopOpacity="0.15" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
